var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"disabled":false,"icon":true,"to":{name:'current-sharing'}}},[_c('v-icon',{attrs:{"x-large":"","color":"primary"}},[_vm._v("\n    mdi-share-variant\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }